import React, { lazy } from 'react';
import { Hero } from '../components/home/Hero';
import { EmotionalPain } from '../components/home/EmotionalPain';
import { BigIdea } from '../components/home/BigIdea';
import { SignGrid } from '../components/home/SignGrid';
import { Problema } from '../components/home/Problema';
import { Solucion } from '../components/home/Solucion';
import { ComoFunciona } from '../components/home/ComoFunciona';
import { ParaQuien } from '../components/home/ParaQuien';
import { Reviews } from '../components/home/Reviews';
import { Productos } from '../components/home/Productos';
import { ExperiencePreview } from '../components/home/ExperiencePreview';
import { DesbloqueoSection } from '../components/home/DesbloqueoSection';
import { FAQ } from '../components/home/FAQ';
import { TuReinoYaExiste } from '../components/home/TuReinoYaExiste';
import { Disclaimer } from '../components/home/Disclaimer';
const PROBLEMA_SOLUCION_BG = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/Wo_P7B_zdv8m9RvhXj7oHsrVCD8DHmoaCV8LM93AvU4jwAaKiGqzNwGb4XYEagB9_tZ0TcHraHRe_tnjw_TqjyQZxuHl5rbrSK5lMOirgN3ahHy_2wo6yUvf1xmSggU58NRTNKzMv.jpg?v=1778629047';
export function Home() {
  return <div className="w-full" data-id="element-1148">
      <Hero data-id="element-1149" />

      <ExperiencePreview data-id="element-1150" />

      <DesbloqueoSection data-id="element-1151" />

      {/* Emotional setup BEFORE the 12 Reinos selector */}
      <EmotionalPain data-id="element-1152" />
      <BigIdea data-id="element-1153" />

      <ComoFunciona data-id="element-1154" />

      <SignGrid data-id="element-1155" />

      {/* Combined background for Problema + Solución */}
      <div className="relative" data-id="element-1156">
        <div className="absolute inset-0 z-0" data-id="element-1157">
          <img src={PROBLEMA_SOLUCION_BG} alt="" aria-hidden="true" className="w-full h-full object-cover" loading="lazy" data-id="element-1158" />
          {/* Dark overlay for legibility */}
          <div className="absolute inset-0 bg-cosmic-black/75" data-id="element-1159" />
          <div className="absolute inset-0" style={{
          background: 'linear-gradient(180deg, #050508 0%, rgba(5,5,8,0.55) 25%, rgba(5,5,8,0.55) 75%, #050508 100%)'
        }} data-id="element-1160" />
        </div>
        <div className="relative z-10" data-id="element-1161">
          <Problema data-id="element-1162" />
          <Solucion data-id="element-1163" />
        </div>
      </div>

      <ParaQuien data-id="element-1164" />
      <Reviews data-id="element-1165" />
      <Productos data-id="element-1166" />
      <FAQ data-id="element-1167" />
      <TuReinoYaExiste data-id="element-1168" />
      <Disclaimer data-id="element-1169" />
    </div>;
}